// Dependencies
import React from "react";
import PropTypes from "prop-types";

// styles
import { useStyles } from "./VideoEmbed.styles";

const VideoEmbed = ({ medium }) => {
  const { mediumType } = medium;
  const classes = useStyles({ mediumType });

  const getEmbedUrl = () => {
    if (medium?.mediumType === "tiktok") {
      return `https://www.tiktok.com/embed/${medium.url
        .split("?")[0]
        .substring(medium.url.lastIndexOf("/") + 1)}`;
    }
    if (medium?.mediumType === "youtube") {
      return `https://www.youtube.com/embed/${medium.url.substring(
        medium.url.indexOf("=") + 1,
      )}`;
    }
    return null;
  };

  return (
    <div className={classes.responsiveVideo} data-component="VideoEmbed">
      <iframe
        loading="lazy"
        className={classes.videoIframe}
        width="853"
        height="480"
        src={getEmbedUrl()}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="Embedded video"
      />
    </div>
  );
};

VideoEmbed.propTypes = {
  medium: PropTypes.string.isRequired,
};

export default VideoEmbed;
